import moment from "moment";
let workOrder = localStorage.getItem("workOrderObj");
if (workOrder) {
  workOrder = JSON.parse(workOrder);
}

let label = [];
let zipprLayer;
let zipprParentLayer;
let enveronment;

var formatStr = "YYYY-MM-DD";
var today = moment()
  .subtract(1, "days")
  .format(formatStr);

if (workOrder) {
  if (workOrder.hierarchy) {
    console.log(workOrder.hierarchy, "workOrder.hierarchy");
    label = workOrder.hierarchy;
    let len = workOrder.hierarchy.length;
    zipprLayer = workOrder.hierarchy[len - 1];
    zipprParentLayer = workOrder.hierarchy[len - 2];
  } else {
    label = "";
  }
}

let type = localStorage.getItem("type");
type = JSON.parse(type);
console.log(typeof type, "type in metadata");

let loginDetails = localStorage.getItem("loginDetails");
loginDetails = JSON.parse(loginDetails);
let sessionToken = "";
if (loginDetails) {
  sessionToken = loginDetails["x-zippr-sessiontoken"];
  console.log(typeof sessionToken, "loginDetailsloginDetails");
}

let work_order;
if (workOrder) {
  work_order = workOrder.workOrder;
} else {
  work_order = "";
}
//localStorage.getItem("workOrderObj")
console.log(label, "label in metadata..");
if (label) {
}

let timeKey = localStorage.getItem("dateFilter");
timeKey = JSON.parse(timeKey);
if (!timeKey) {
  timeKey = "lifetime";
}

let envUrl = "";
console.log(
  process.env.REACT_APP_NOT_SECRET_CODE,
  "process.env.REACT_APP_NOT_SECRET_CODE"
);
// if(process.env.NODE_ENV=='development'){
if (process.env.REACT_APP_NOT_SECRET_CODE == "dev") {
  envUrl = "dev.zip.pr";
} else if (process.env.REACT_APP_NOT_SECRET_CODE == "prod") {
  envUrl = "dashboard.zip.pr";
} else {
  envUrl = "dev.zip.pr";
}

let loginUrl = "";
if (process.env.REACT_APP_NOT_SECRET_CODE == "dev") {
  loginUrl = "dev.zip.pr";
  enveronment = "dev";
} else if (process.env.REACT_APP_NOT_SECRET_CODE == "prod") {
  loginUrl = "api.zip.pr";
  enveronment = "dashboard";
} else {
  loginUrl = "dev.zip.pr";
  enveronment = "dev";
}

console.log(envUrl, "envronment", process.env.NODE_ENV);

let apiData = [
  {
    project: work_order,
    layers_count: 3,
    polygonLayer: {
      url: `https://${envUrl}/ddn-dashboard/v2/st-clusters`,
      params: {
        work_order: work_order
      }
    },
    layer_1: {
      url: `https://${envUrl}/ddn-dashboard/v2/st-clusters`,
      params: {
        work_order: work_order,
        label: label[0]
      }
    },
    layer_2: {
      url: `https://${envUrl}/ddn-dashboard/v2/st-clusters`,
      params: {
        work_order: work_order,
        label: label[1]
      }
    },
    layer_3: {
      url: `https://${envUrl}/ddn-dashboard/v2/st-clusters`,
      params: {
        work_order: work_order,
        label: workOrder ? workOrder.hierarchy[2] : ""
      }
    },
    layer_4: {
      url: `https://${envUrl}/ddn-dashboard/v2/st-clusters`,
      params: {
        work_order: work_order,
        label: workOrder ? workOrder.hierarchy[3] : ""
      }
    },
    layer_5: {
      url: `https://${envUrl}/ddn-dashboard/v2/st-clusters`,
      params: {
        work_order: work_order,
        label: workOrder ? workOrder.hierarchy[4] : ""
      }
    },
    // layer_6:{
    //     url:'https://dev.zip.pr/ddn-dashboard/v2/st-clusters',
    //     params: {
    //         work_order: work_order,
    //         label: workOrder ? workOrder.hierarchy[5] : ""
    //       },
    // },
    zipprs_layer: {
      url: `https://${envUrl}/ddn-dashboard/v2/marked-zipprs`,
      params: {
        work_order: work_order,
        spaceKey: zipprLayer,
        parentKey: zipprParentLayer,
        analyticsType: type,
        // zp_type:7,
        // timeKey: "today",
        timeKey: "lifetime",
        // fromDate: moment()
        //   .subtract(1, "days")
        //   .format("YYYY-MM-DD"),
        spaceValue: "",
        parentValue: "",
        analyticsType: type
      }
    },
    analytics_layer_1: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        analyticsType: type,
        work_order: work_order,
        spaceCategory: "regular",
        // timeKey: timeKey,
        userKey: "allClients",
        // timeKey: "today",
        timeKey: "lifetime",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD")
      }
    },
    analytics_layer_2: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        analyticsType: type,
        work_order: work_order,
        spaceCategory: "regular",
        // timeKey: timeKey,
        timeKey: "lifetime",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        userKey: "allClients"
        // spaceKey: "city"
      }
    },
    analytics_layer_3: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        analyticsType: type,
        work_order: work_order,
        spaceCategory: "regular",
        // timeKey: timeKey,
        timeKey: "lifetime",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        userKey: "allClients"
        // spaceKey: workOrder ? workOrder.hierarchy[2] : ""
      }
    },
    analytics_layer_4: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        analyticsType: type,
        work_order: work_order,
        spaceCategory: "regular",
        // timeKey: timeKey,
        timeKey: "lifetime",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        userKey: "allClients"
        // spaceKey: workOrder ? workOrder.hierarchy[3] : ""
      }
    },
    analytics_layer_5: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        analyticsType: type,
        work_order: work_order,
        spaceCategory: "regular",
        // timeKey: timeKey,
        timeKey: "lifetime",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        userKey: "allClients"
        // spaceKey: workOrder ? workOrder.hierarchy[4] : ""
      }
    },
    // analytics_layer_6:{
    //     url:'https://dev.zip.pr/ddn-dashboard/v2/analytics-summary',
    //     params: {
    //     analyticsType:type,
    //     work_order:work_order,
    //     spaceCategory:"regular",
    //     timeKey:"lifetime",
    //     userKey:"allClients",
    //     spaceKey: workOrder ? workOrder.hierarchy[5] :""
    //     }
    // },
    add_client: {
      url: `https://${envUrl}/ddn-dashboard/v2/client`,
      params: {
        work_order: work_order
      }
    },
    workorder_projects: {
      url: `https://${loginUrl}/internal-dashboard/v1/client-user/wo-projects`,
      params: {
        work_order: work_order
      }
    },
    client_list: {
      url: `https://${envUrl}/ddn-dashboard/v2/client-list`,
      params: {
        work_order: work_order
      }
    },
    ward_list: {
      url: `https://${envUrl}/ddn-dashboard/v2/wards-list`,
      params: {
        work_order: work_order
      }
    },
    ward_report_clients: {
      url: `https://${envUrl}/ddn-dashboard/v2/workorder-clients`,
      params: {
        work_order: work_order
      }
    },
    ward_report_users: {
      url: `https://${envUrl}/ddn-dashboard/v2/client-users`,
      params: {
        work_order: work_order
      }
    },
    ward_analytics: {
      url: `https://${envUrl}/ddn-dashboard/v2/ward-analytics`,
      // url: `https://dashboard.zip.pr/ddn-dashboard/v2/ward-analytics`,
      params: {
        work_order
      }
    },
    ward_ddns: {
      url: `https://${envUrl}/ddn-dashboard/v2/ward-ddns`,
      // url: `https://dashboard.zip.pr/ddn-dashboard/v2/ward-ddns`,
      params: {
        work_order
      }
    },
    download_metadata: {
      url: `https://${envUrl}/ddn-dashboard/v2/download-metadata`,
      // url: `https://dashboard.zip.pr/ddn-dashboard/v2/ward-ddns`,
      params: {
        work_order
      }
    },
    property_anaylytics: {
      url: `https://${envUrl}/ddn-dashboard/v2/property-analytics`,
      params: {
        work_order
      }
    },
    agency_analytics: {
      url: `https://${envUrl}/ddn-dashboard/v2/agency-analytics`,
      // url: `https://dashboard.zip.pr/ddn-dashboard/v2/ward-ddns`,
      params: {
        work_order
      }
    },
    user_analytics: {
      url: `https://${envUrl}/ddn-dashboard/v2/user-analytics`,
      // url: `https://dashboard.zip.pr/ddn-dashboard/v2/ward-ddns`,
      params: {
        work_order
      }
    },
    ulb_treeDtata: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        analyticsType: type,
        work_order: work_order,
        spaceCategory: "regular",
        timeKey: "lifetime",
        userKey: "allClients"
      }
    },
    agency_data: {
      url: `https://${envUrl}/ddn-dashboard/v2/analytics-summary`,
      params: {
        work_order: work_order,
        spaceCategory: "regular",
        analyticsType: type,
        timeKey: "today",
        // timeKey: "lifetime",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        spaceKey: label[1],
        userKey: "allClients" //changed agent to allClients bcz issue in home ulb
      }
    },
    agent_summary: {
      url: `https://${envUrl}/ddn-dashboard/v2/agency-attendance`,
      params: {
        work_order: work_order,
        spaceCategory: "regular",
        analyticsType: type,
        // timeKey: timeKey,
        timeKey: "today",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        spaceKey: label[0]
      }
    },
    workOrder: {
      url: `https://${envUrl}/ddn-dashboard/v2/workorder`,
      params: {
        work_order: work_order
      }
    },
    workOrderClients: {
      url: `https://${envUrl}/ddn-dashboard/v2/workorder-clients`,
      params: {
        work_order: work_order
      }
    },
    downloadDataFromMap: {
      url: `https://${envUrl}/ddn-dashboard/v2/download-zipprs`,
      params: {
        work_order: work_order,
        isMarked: true,
        analyticsType: type
        // zp_type: 7
      }
    },
    downloadLocalityDdnData: {
      url: `https://${envUrl}/ddn-dashboard/v2/locality-ddns`,
      params: {
        work_order: work_order,
        locality: ''
        // zp_type: 7
      }
    },
    recentActivity: {
      url: `https://${envUrl}/ddn-dashboard/v2/recent-activity`,
      params: {
        work_order: work_order,
        analyticsType: type
      }
    },
    snapShot: {
      url: `https://${envUrl}/ddn-dashboard/v2/snapshot`,
      params: {
        work_order: work_order,
        surveyType: type,
        spaceCategory: "regular",
        analyticsType: type,
        // fromDate: "2020-01-19",
        fromDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        spaceKey: label[0]
      }
    },
    zipprDetails: {
      url: `https://${envUrl}/ddn-dashboard/v2/zippr`,
      params: {
        zippr: ""
      }
    },
    hourlyZipprs: {
      url: `https://${envUrl}/ddn-dashboard/v2/hourly-zipprs`,
      params: {
        work_order: work_order,
        analyticsType: type
      }
    },
    login: {
      url: `https://${loginUrl}/v3/internal/users/login`,
      params: {
        username: "",
        password: ""
      }
    },
    getDwellings: {
      url: `https://${envUrl}/ddn-dashboard/v2/dwellings`,
      params: {
        work_order: work_order,
        building_zippr: ""
      }
    },
    metadata: {
      url: `https://${envUrl}/ddn-dashboard/v2/metadata`,
      params: {
        work_order: work_order,
        isList: false,
        zippr: ""
      }
    },
    getWorkOrders: {
      url: `https://${enveronment}.zip.pr/ddn-dashboard/v2/all-workorders`
    },
    workorderDetails: {
      url: `https://${enveronment}.zip.pr/ddn-dashboard/v2/workorder`
    },
    getAllWorkorders: {
      url: `https://${loginUrl}/internal-dashboard/v1/workorder/all`,
      params: {}
    },
    getAppsList: {
      url: `https://${loginUrl}/internal-dashboard/v1/client-user/app-list`,
      params: {}
    },
    getWorkorderClients: {
      url: `https://${loginUrl}/internal-dashboard/v1/client-user/wo-clients`,
      params: {}
    },
    getClientProjects: {
      url: `https://${loginUrl}/internal-dashboard/v1/client-user/client-projects`,
      params: {}
    },
    addAgent: {
      url: `https://${loginUrl}/internal-dashboard/v1/client-user/agent`,
      params: {}
    },
    deleteAgent: {
      url: `https://${loginUrl}/internal-dashboard/v1/client-user/agent`,
      params: {}
    },
    blockAgent: {
      url: `https://${enveronment}.zip.pr/ddn-dashboard/v2/block-agent`,
      params: {}
    },
    blockAgent_2: {
      url: `https://${envUrl}/ddn-dashboard/v2/block-client`,
      params: {}
    },
    unBlockAgent: {
      url: `https://${enveronment}.zip.pr/ddn-dashboard/v2/unblock-agent`,
      params: {}
    },
    unBlockAgent_2: {
      url: `https://${envUrl}/ddn-dashboard/v2/unblock-client`,
      params: {}
    },
    logoutAgent: {
      url: `https://${envUrl}/ddn-dashboard/v2/logout-client`,
      params: {}
    },
    userDetails: {
      url: `https://${enveronment}.zip.pr/ddn-dashboard/v2/user-details`,
      params: {}
    },
    agentDetails: {
      url: `https://${enveronment}.zip.pr/ddn-dashboard/v2/agent`,
      params: {}
    },

    headers: {
      "Content-Type": "application/json",
      "x-zippr-api-key":
        "1e1352a39ebd3db612cc233e8519bee7f36ca655c43e6cf1783e58c1b31a2d7c",
      "x-zippr-sessiontoken": sessionToken
    },
    addDates: query => {
      var formatStr = "YYYY-MM-DD";
      var today = moment()
        .subtract(1, "days")
        .format(formatStr);
      switch (query.timeKey) {
        case "today":
          query.fromDate = today;
          query.timeKey = "today";
          break;
        case "yesterday":
          query.fromDate = moment()
            .subtract(2, "days")
            .format(formatStr);
          query.toDate = today;
          query.timeKey = "today";
          break;
        case "this_week":
          query.fromDate = moment()
            .startOf("week")
            .format(formatStr);
          query.toDate = moment().format(formatStr);
          query.timeKey = "today";
          break;
        case "last_week":
          query.fromDate = moment()
            .startOf("week")
            .subtract(7, "days")
            .format(formatStr);
          query.toDate = moment()
            .startOf("week")
            .subtract(1, "days")
            .format(formatStr);
          query.timeKey = "today";
          break;
        case "last_7":
          query.fromDate = moment()
            .subtract(7, "days")
            .format(formatStr);
          query.toDate = moment()
            .subtract(1, "days")
            .format(formatStr);
          query.timeKey = "today";
          break;
        case "last_14":
          query.fromDate = moment()
            .subtract(14, "days")
            .format(formatStr);
          query.toDate = moment()
            .subtract(1, "days")
            .format(formatStr);
          query.timeKey = "today";
          break;

        // case 'this_month':
        //     query.fromDate = moment().startOf('month').format(formatStr);
        //     query.timeKey = 'month';
        //     break;
        // case 'last_month':
        //     query.fromDate = moment().subtract(1, 'months').startOf('month').format(formatStr);
        //     query.toDate = moment().subtract(1, 'months').endOf('month').format(formatStr);
        //     query.timeKey = 'month';
        //     break;
        // case 'this_year':
        //     // query.fromDate = yearObj.startOf('year').format(formatStr);
        //     query.fromDate = moment().startOf('year').format(formatStr);
        //     query.toDate = today;
        //     query.timeKey = 'year';
        //     break;

        case "this_month":
          query.fromDate = moment()
            .startOf("month")
            .subtract(1, "days")
            .format(formatStr);
          query.timeKey = "month";
          break;
        case "last_month":
          query.fromDate = moment()
            .subtract(1, "months")
            .startOf("month")
            .subtract(1, "days")
            .format(formatStr);
          query.toDate = moment()
            .subtract(1, "months")
            .endOf("month")
            .subtract(1, "days")
            .format(formatStr);
          query.timeKey = "month";
          break;
        case "this_year":
          query.fromDate = moment()
            .startOf("year")
            .subtract(1, "days")
            .format(formatStr);
          query.toDate = today;
          query.timeKey = "year";
          break;

        case "lifetime":
          query.fromDate = "";
          query.toDate = "";
          query.timeKey = "lifetime";
          break;
        default:
          query.fromDate = today;
          query.timeKey = "today";
      }
    }
  }
];

// sessionStorege.setapiData[0].ulb_treeDtata
localStorage.setItem(
  "ulbTreeParams",
  JSON.stringify(apiData[0].ulb_treeDtata.params)
);
localStorage.setItem("allApis", JSON.stringify(apiData[0]));

export default apiData;
